import React from 'react';
import { PapiUser } from '@wix/da-types-papi';
import { withTranslation, WithTranslation } from 'react-i18next';
import classnames from 'classnames';
import CommentThread, {
  CommentableTypes,
} from '@wix/da-shared-react/pkg/CommentThread';
import {
  BiLoggerContextProvider,
  BiDataHook,
} from '@wix/da-shared-react/pkg/biLogger';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';

import s from './ProfileComments.scss';

export type Props = {
  currentUser: PapiUser;
  profileOwnerUser: PapiUser;
  isOwner: boolean;
  isMobile: boolean;
  totalCount: number;
  commentV2?: boolean;
} & Pick<WidgetBoxProps, 'moduleId' | 'section' | 'zone'>;

export class ProfileCommentsBox extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const {
      widgetRemove,
      isMobile,
      commentV2,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={
          commentV2 && isMobile
            ? null
            : props.t!('widgets.profileComments.header')
        }
        count={isMobile ? undefined : props.totalCount}
        moduleId={props.moduleId}
        widgetRemove={widgetRemove}
        dataHook={BiDataHook.WIDGET_PROFILE_COMMENTS}
      >
        <div className={classnames(s['root'], commentV2 && s['commentv2'])}>
          <BiLoggerContextProvider
            value={{ widgetname: 'comments', sectionname: 'comments' }}
          >
            <CommentThread
              className={classnames(!commentV2 && s['comment-thread'])}
              currentUser={props.currentUser}
              commentableTypeId={CommentableTypes.COMMENT_USER}
              commentableItemId={props.profileOwnerUser.userId}
              commentBoxClassName={s['comment-box']}
              useCardLayout
              postbox="top"
              statsAndControls={isMobile ? 'on' : 'off'}
              compact
            />
          </BiLoggerContextProvider>
        </div>
      </WidgetBox>
    );
  }
}

export default withTranslation()(ProfileCommentsBox) as React.ComponentType<
  Props
>;
